/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PostSlugRouteImport } from './routes/post.$slug'
import { Route as SearchTermRouteImport } from './routes/search.$term'
import { Route as TagSlugRouteImport } from './routes/tag.$slug'
import { Route as WebhooksWordpressRouteImport } from './routes/webhooks/wordpress'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostSlugRoute = PostSlugRouteImport.update({
  id: '/post/$slug',
  path: '/post/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchTermRoute = SearchTermRouteImport.update({
  id: '/search/$term',
  path: '/search/$term',
  getParentRoute: () => rootRouteImport,
} as any)
const TagSlugRoute = TagSlugRouteImport.update({
  id: '/tag/$slug',
  path: '/tag/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksWordpressRoute = WebhooksWordpressRouteImport.update({
  id: '/webhooks/wordpress',
  path: '/webhooks/wordpress',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/post/$slug': typeof PostSlugRoute
  '/search/$term': typeof SearchTermRoute
  '/tag/$slug': typeof TagSlugRoute
  '/webhooks/wordpress': typeof WebhooksWordpressRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/post/$slug': typeof PostSlugRoute
  '/search/$term': typeof SearchTermRoute
  '/tag/$slug': typeof TagSlugRoute
  '/webhooks/wordpress': typeof WebhooksWordpressRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/post/$slug': typeof PostSlugRoute
  '/search/$term': typeof SearchTermRoute
  '/tag/$slug': typeof TagSlugRoute
  '/webhooks/wordpress': typeof WebhooksWordpressRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/post/$slug'
    | '/search/$term'
    | '/tag/$slug'
    | '/webhooks/wordpress'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/post/$slug'
    | '/search/$term'
    | '/tag/$slug'
    | '/webhooks/wordpress'
  id:
    | '__root__'
    | '/'
    | '/post/$slug'
    | '/search/$term'
    | '/tag/$slug'
    | '/webhooks/wordpress'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PostSlugRoute: typeof PostSlugRoute
  SearchTermRoute: typeof SearchTermRoute
  TagSlugRoute: typeof TagSlugRoute
  WebhooksWordpressRoute: typeof WebhooksWordpressRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/$slug': {
      id: '/post/$slug'
      path: '/post/$slug'
      fullPath: '/post/$slug'
      preLoaderRoute: typeof PostSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search/$term': {
      id: '/search/$term'
      path: '/search/$term'
      fullPath: '/search/$term'
      preLoaderRoute: typeof SearchTermRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tag/$slug': {
      id: '/tag/$slug'
      path: '/tag/$slug'
      fullPath: '/tag/$slug'
      preLoaderRoute: typeof TagSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks/wordpress': {
      id: '/webhooks/wordpress'
      path: '/webhooks/wordpress'
      fullPath: '/webhooks/wordpress'
      preLoaderRoute: typeof WebhooksWordpressRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PostSlugRoute: PostSlugRoute,
  SearchTermRoute: SearchTermRoute,
  TagSlugRoute: TagSlugRoute,
  WebhooksWordpressRoute: WebhooksWordpressRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { createStart } from '@tanstack/react-start'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
  }
}
